import React, { useEffect, useRef, useState } from "react";
import {
  FiArrowLeft,
  FiArrowRight,
  FiUser,
  FiHelpCircle,
  FiHome,
} from "react-icons/fi";
import { BsCarFront } from "react-icons/bs";
import { IoSettingsOutline } from "react-icons/io5";
import { MdOutlineErrorOutline } from "react-icons/md";
import { Dropdown } from "primereact/dropdown";
import styles from "./VehiclePopup.module.css";
import { Vehicle, Service } from "../types";
import { useNavigate } from "react-router-dom";
import useHeroAPI from "../../../../api/useHeroAPI";
import useVehicleAPI from "../../../../api/useVehicleAPI";
import { setShowLoginDialog } from "../../../../redux/dialogSlice";
import { useDispatch } from "react-redux";
import { Toast } from "primereact/toast";
import AccountTypeModal, {
  AccountType,
} from "../../Login_Page/AccountTypeModal";
import LoginModal from "../../Login_Page/LoginModal";

interface Option {
  name: string;
  code: string;
}

interface VehiclePopupProps {
  isOpen: boolean;
  onClose: () => void;
  vehicles: Vehicle[];
  onAddVehicle: (newVehicle: Omit<Vehicle, "id">) => void;
  selectedVehicleId: string | null;
  onSelectVehicleId: (id: string) => void;
  activeService: Service | null;
  onBookService: (service: Service, vehicle: Vehicle) => void;
}

export default function VehiclePopup({
  isOpen,
  onClose,
  vehicles,
  onAddVehicle,
  selectedVehicleId,
  onSelectVehicleId,
  activeService,
  onBookService,
}: VehiclePopupProps) {
  const toast = useRef<any>(null);
  const dispatch = useDispatch();
  const basePath = process.env.REACT_APP_BASE_PATH;
  const navigate = useNavigate();

  const { predefinedFunc } = useHeroAPI();
  const { saveVehicle } = useVehicleAPI();

  // Form fields (new cascading dropdown model)
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [categories, setCategories] = useState<Option[]>([]);
  const [category, setCategory] = useState<Option | null>(null);
  const [makes, setMakes] = useState<Option[]>([]);
  const [make, setMake] = useState<Option | null>(null);
  const [models, setModels] = useState<Option[]>([]);
  const [model, setModel] = useState<Option | null>(null);
  const [variants, setVariants] = useState<Option[]>([]);
  const [variant, setVariant] = useState<Option | null>(null);
  const [submitted, setSubmitted] = useState(false);
  const [userId, setUserId] = useState(null) as any;

  const [login, setLogin] = useState(false) as any;
  const [showVinGuide, setShowVinGuide] = useState(false);
  const [authStep, setAuthStep] = useState<"none" | "accountType" | "login">(
    "none",
  );
  const [selectedAccountType, setSelectedAccountType] =
    useState<AccountType>("customer");
  // Fetch categories on mount
  useEffect(() => {
    const authTokens = JSON.parse(localStorage.getItem("authTokens") || "{}");

    const userId = authTokens?.user?.id;

    // console.log(userId, "userIdLLLLLLLLLLLLLLLLLL")
    if (!userId) {
      // console.log(userId, "usLLLLLLLLLLLLLL")
      setLogin(false);
      toast.current?.show({
        severity: "error",
        summary: "Failed",
        detail: "Please Login",
      });
      return;
    }
    // console.log("usLLLLLLLLLLLLLL");

    setLogin(true);
    const fetchCategories = async () => {
      const TyrePayload = { code: "TYRE", entity_type: "PRODUCT-TYPE" };
      const TyreResponse = await predefinedFunc(TyrePayload);
      const payload = {
        entity_type: "CATEGORY",
        categoryParentID: TyreResponse?.data?.data[0]?.predefined_id,
      };
      const response = await predefinedFunc(payload);
      if (response?.status === 200) {
        const data = response?.data?.data?.map((c: any) => ({
          name: c.name,
          code: c.predefined_id,
        }));
        setCategories(data || []);
      }
    };
    fetchCategories();
  }, []);

  // Fetch makes when category changes
  useEffect(() => {
    setMake(null);
    setModel(null);
    setVariant(null);
    setMakes([]);
    setModels([]);
    setVariants([]);

    if (!category) return;

    const fetchMakes = async () => {
      const payload = { entity_type: "MAKE", parent_id: category.code };
      const response = await predefinedFunc(payload);
      const data = response?.data?.data?.map((c: any) => ({
        name: c.name,
        code: c.predefined_id,
      }));
      setMakes(data || []);
    };
    fetchMakes();
  }, [category]);

  // Fetch models when make changes
  useEffect(() => {
    setModel(null);
    setVariant(null);
    setModels([]);
    setVariants([]);

    if (!make) return;

    const fetchModels = async () => {
      const payload = { entity_type: "MODEL", parent_id: make.code };
      const response = await predefinedFunc(payload);
      const data = response?.data?.data?.map((c: any) => ({
        name: c.name,
        code: c.predefined_id,
      }));
      setModels(data || []);
    };
    fetchModels();
  }, [make]);

  // Fetch variants when model changes
  useEffect(() => {
    setVariant(null);
    setVariants([]);

    if (!model) return;

    const fetchVariants = async () => {
      const payload = { entity_type: "VARIANT", parent_id: model.code };
      const response = await predefinedFunc(payload);
      const data = response?.data?.data?.map((c: any) => ({
        name: c.name,
        code: c.predefined_id,
      }));
      setVariants(data || []);
    };
    fetchVariants();
  }, [model]);

  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      // onClose();
    }
  };

  const selectedVehicle = vehicles.find((v) => v.id === selectedVehicleId);
  // console.log(selectedVehicle, "selectedVehicle");

  const resetForm = () => {
    setVehicleNumber("");
    setCategory(null);
    setMake(null);
    setModel(null);
    setVariant(null);
    setSubmitted(false);
  };

  const handleSubmitNewVehicle = async (e: React.FormEvent) => {
    e.preventDefault();

    const authTokens = JSON.parse(localStorage.getItem("authTokens") || "{}");

    const userId = authTokens?.user?.id;

    if (!userId) {
      dispatch(setShowLoginDialog(true));

      toast.current?.show({
        severity: "error",
        summary: "Failed",
        detail: "Please Login",
      });

      return;
    }

    if (!vehicleNumber || !category || !make || !model || !variant) {
      setSubmitted(true);
      return;
    }

    const payload = {
      vehicle_number: vehicleNumber,
      category_id: category.code,
      make_id: make.code,
      model_id: model.code,
      variant_id: variant.code,
    };

    const formData = new FormData();
    formData.append("data", JSON.stringify(payload));

    const response = await saveVehicle(formData);

    if (response?.status === 200 || response?.status === 201) {
      onAddVehicle({
        // Adjust these fields to match your actual Vehicle interface
        nickname: vehicleNumber,
        vin: vehicleNumber,
        year: "",
        make: make.name,
        model: model.name,
        variant_id: Number(variant.code),
        tags: [category.name, variant.name],
        lastService: "N/A",
      } as Omit<Vehicle, "id">);

      resetForm();
    }
  };

  const handleBooking = () => {
    if (!selectedVehicle) return;
    onBookService(activeService!, selectedVehicle);
  };
  const handleLoginClick = () => {
    setAuthStep("accountType");
    // setLogin(true);
  };
  const handleHomeClick = () => {
    if (!login) {
      navigate("/");
    }
  };
  return (
    <>
      {!login ? (
        // SHOW LOGIN PROMPT
        <div
          id="vehicle-popup-overlay"
          className={styles.overlay}
          onClick={handleOverlayClick}
        >
          {authStep === "accountType" && (
            <AccountTypeModal
              visible={authStep === "accountType"}
              onHide={() => setAuthStep("none")}
              onSelect={(type) => {
                setSelectedAccountType(type);
                setAuthStep("login");
              }}
            />
          )}

          <LoginModal
            visible={authStep === "login"}
            onHide={() => setAuthStep("none")}
            accountType={selectedAccountType}
            onLoginSuccess={() => {
              const authTokens = JSON.parse(
                localStorage.getItem("authTokens") || "{}",
              );
              setUserId(authTokens?.user?.id);
              setAuthStep("none");

              // if (pendingAction === "cart") handleAddToCart();
              // if (pendingAction === "wishlist") {
              //   handleWishlistToggle({ stopPropagation: () => { } } as any);
              // }
              // setPendingAction(null);
            }}
          />
          <div className={styles.loginPromptContainer}>
            <div className={styles.loginPromptCard}>
              <div className={styles.loginPromptIcon}>
                <FiUser size={48} />
              </div>
              <h3 className={styles.loginPromptTitle}>Login Required</h3>
              <p className={styles.loginPromptMessage}>
                Please login to explore the service and repair section
              </p>
              <div className={styles.loginButton}>
                <button
                  className={styles.loginPromptButtonHome}
                  onClick={handleHomeClick}
                >
                  <span>Home</span>
                  <FiHome size={18} />
                </button>
                <button
                  className={styles.loginPromptButton}
                  onClick={handleLoginClick}
                >
                  <span>Login Now</span>
                  <FiArrowRight size={18} />
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <Toast ref={toast} />
          <div
            id="vehicle-popup-overlay"
            className={styles.overlay}
            // onClick={handleOverlayClick}
          >
            <div id="vehicle-popup-modal" className={styles.modal}>
              {/* Header */}
              <div className={styles.header}>
                <div className={styles.headerLeft}>
                  <button
                    id="back-button"
                    className={styles.backButton}
                    onClick={() => navigate(`${basePath}`)}
                  >
                    <FiArrowLeft size={20} />
                  </button>
                  <h2 id="header-title" className={styles.headerTitle}>
                    Select Vehicle
                  </h2>
                </div>
                <div className={styles.userIcon}>
                  <FiUser size={18} />
                </div>
              </div>

              {/* Content Area */}
              <div className={styles.content}>
                {/* List of Vehicles */}
                <div className={styles.vehiclesSection}>
                  <h3 className={styles.sectionTitle}>My Vehicles</h3>
                  <p className={styles.sectionSubtitle}>
                    Choose the vehicle for this service
                  </p>

                  <div className={styles.vehicleGrid}>
                    {vehicles.map((v) => {
                      const isActive = v.id === selectedVehicleId;
                      return (
                        <div
                          id={`vehicle-card-${v.id}`}
                          key={v.id}
                          className={`${styles.vehicleCard} ${isActive ? styles.vehicleCardActive : ""}`}
                          onClick={() => onSelectVehicleId(v.id)}
                        >
                          <div
                            className={`${styles.carIconContainer} ${isActive ? styles.carIconContainerActive : ""}`}
                          >
                            <BsCarFront size={24} />
                          </div>
                          <div className={styles.vehicleDetails}>
                            <h4 className={styles.carName}>
                              {v.year} {v.make} {v.model}
                            </h4>
                            <div className={styles.vinNumber}>
                              Vehicle Number: {v.vin}
                            </div>
                            {v.tags && (
                              <div className={styles.tagsContainer}>
                                {v.tags.map((tag, i) => (
                                  <span key={i} className={styles.tagBadge}>
                                    {tag}
                                  </span>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Form to Add New Vehicle */}
                <div className={styles.formSection}>
                  <h3 className={styles.formTitle}>Add New Vehicle</h3>

                  <form onSubmit={handleSubmitNewVehicle}>
                    {/* Vehicle Number + Category in one row */}
                    <div className={styles.rowInputs}>
                      <div className={styles.formGroup}>
                        <label className={styles.formLabel}>
                          Vehicle Number
                        </label>
                        <input
                          id="input-vehicle-number"
                          type="text"
                          maxLength={13}
                          placeholder="Vehicle Number"
                          className={styles.textInput}
                          value={vehicleNumber}
                          onChange={(e) => setVehicleNumber(e.target.value)}
                        />
                        {submitted && !vehicleNumber && (
                          <small className="error">
                            Vehicle Number is Required
                          </small>
                        )}
                      </div>

                      <div className={styles.formGroup}>
                        <label className={styles.formLabel}>Category</label>
                        <Dropdown
                          id="input-category"
                          className={styles.dropdown}
                          value={category}
                          options={categories}
                          optionLabel="name"
                          onChange={(e) => setCategory(e.value)}
                          placeholder="Select a Category"
                          showClear
                        />
                        {submitted && !category && (
                          <small className="error">Category is Required</small>
                        )}
                      </div>
                    </div>

                    <div className={styles.rowInputs}>
                      <div className={styles.formGroup}>
                        <label className={styles.formLabel}>Make</label>
                        <Dropdown
                          id="input-make"
                          className={styles.dropdown}
                          value={make}
                          options={makes}
                          optionLabel="name"
                          onChange={(e) => setMake(e.value)}
                          placeholder="Select a Make"
                          filter
                          disabled={!category}
                        />
                        {submitted && !make && (
                          <small className="error">Make is Required</small>
                        )}
                      </div>
                      <div className={styles.formGroup}>
                        <label className={styles.formLabel}>Model</label>
                        <Dropdown
                          id="input-model"
                          className={styles.dropdown}
                          value={model}
                          options={models}
                          optionLabel="name"
                          onChange={(e) => setModel(e.value)}
                          placeholder="Select a Model"
                          filter
                          disabled={!make}
                        />
                        {submitted && !model && (
                          <small className="error">Model is Required</small>
                        )}
                      </div>
                    </div>

                    <div className={styles.formGroup}>
                      <label className={styles.formLabel}>Variant</label>
                      <div className={styles.variantRow}>
                        <div>
                          <Dropdown
                            id="input-variant"
                            className={styles.dropdown}
                            value={variant}
                            options={variants}
                            optionLabel="name"
                            onChange={(e) => setVariant(e.value)}
                            placeholder="Select a Variant"
                            disabled={!model}
                          />
                          {submitted && !variant && (
                            <small className="error">Variant is Required</small>
                          )}
                        </div>
                        <button
                          id="add-to-profile-btn"
                          type="submit"
                          className={styles.addButton}
                        >
                          Add New Vehicle
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              {/* Footer Area */}
              <div className={styles.footer}>
                <div className={styles.footerLeft}>
                  <span className={styles.footerLabel}>Selected Vehicle</span>
                  <span className={styles.footerVehicleName}>
                    {selectedVehicle
                      ? ` ${selectedVehicle.make} ${selectedVehicle.model}`
                      : "None Selected"}
                  </span>
                </div>
                <button
                  id="confirm-booking-btn"
                  className={styles.bookButton}
                  disabled={!selectedVehicle}
                  onClick={handleBooking}
                >
                  <span>Continue</span>
                  <FiArrowRight size={18} />
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
